import { default as fullscreenQ5NsFTfs9XMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/fullscreen.vue?macro=true";
import { default as go_45to_45payment_45providerZNuLicxTmvMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/go-to-payment-provider.vue?macro=true";
import { default as indexTTRar3dlJnMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/index.vue?macro=true";
import { default as mobileDIRDSlYDhfMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/mobile.vue?macro=true";
import { default as modalYHeKFh79zEMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/modal.vue?macro=true";
import { default as orderX6oKwPWsJvMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/order.vue?macro=true";
import { default as payment_45formtJIRCwmngyMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/payment-form.vue?macro=true";
import { default as ticketW46oCrOq9DMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/ticket.vue?macro=true";
import { default as user_45info_45formjm801fsKc9Meta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/user-info-form.vue?macro=true";
import { default as abh_45theatreGaAvucDmF4Meta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/abh-theatre.vue?macro=true";
import { default as chamber_45hall_45minieUVS4ICi30Meta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/chamber-hall-mini.vue?macro=true";
import { default as chamber_45hall6FW75m3f52Meta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/chamber-hall.vue?macro=true";
import { default as main_45halljZomvrtewsMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/main-hall.vue?macro=true";
import { default as marnero_45barRvD69K34PkMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/marnero-bar.vue?macro=true";
import { default as philarmoniya02xzI6RpB7Meta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/philarmoniya.vue?macro=true";
import { default as pitsunda_45summer_45amphitheatereObg5GnAetMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/pitsunda-summer-amphitheater.vue?macro=true";
import { default as pitsunda1deObTOYRLMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/pitsunda.vue?macro=true";
import { default as rusdram_45art_45foyerBacJcdiaVIMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/rusdram-art-foyer.vue?macro=true";
import { default as rusdram_45parterIWiYMLnEpsMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/rusdram-parter.vue?macro=true";
import { default as rusdram_45round_45hallPho9XGV2DZMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/rusdram-round-hall.vue?macro=true";
import { default as stage_45hallXct8gynP3QMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/stage-hall.vue?macro=true";
import { default as indexXpwKw4ncKSMeta } from "/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/index.vue?macro=true";
export default [
  {
    name: "id-fullscreen",
    path: "/:id()/fullscreen",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/fullscreen.vue")
  },
  {
    name: "id-go-to-payment-provider",
    path: "/:id()/go-to-payment-provider",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/go-to-payment-provider.vue")
  },
  {
    name: "id",
    path: "/:id()",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/index.vue")
  },
  {
    name: "id-mobile",
    path: "/:id()/mobile",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/mobile.vue")
  },
  {
    name: "id-modal",
    path: "/:id()/modal",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/modal.vue")
  },
  {
    name: "id-order",
    path: "/:id()/order",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/order.vue")
  },
  {
    name: "id-payment-form",
    path: "/:id()/payment-form",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/payment-form.vue")
  },
  {
    name: "id-ticket",
    path: "/:id()/ticket",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/ticket.vue")
  },
  {
    name: "id-user-info-form",
    path: "/:id()/user-info-form",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/[id]/user-info-form.vue")
  },
  {
    name: "halls-abh-theatre",
    path: "/halls/abh-theatre",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/abh-theatre.vue")
  },
  {
    name: "halls-chamber-hall-mini",
    path: "/halls/chamber-hall-mini",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/chamber-hall-mini.vue")
  },
  {
    name: "halls-chamber-hall",
    path: "/halls/chamber-hall",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/chamber-hall.vue")
  },
  {
    name: "halls-main-hall",
    path: "/halls/main-hall",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/main-hall.vue")
  },
  {
    name: "halls-marnero-bar",
    path: "/halls/marnero-bar",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/marnero-bar.vue")
  },
  {
    name: "halls-philarmoniya",
    path: "/halls/philarmoniya",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/philarmoniya.vue")
  },
  {
    name: "halls-pitsunda-summer-amphitheater",
    path: "/halls/pitsunda-summer-amphitheater",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/pitsunda-summer-amphitheater.vue")
  },
  {
    name: "halls-pitsunda",
    path: "/halls/pitsunda",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/pitsunda.vue")
  },
  {
    name: "halls-rusdram-art-foyer",
    path: "/halls/rusdram-art-foyer",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/rusdram-art-foyer.vue")
  },
  {
    name: "halls-rusdram-parter",
    path: "/halls/rusdram-parter",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/rusdram-parter.vue")
  },
  {
    name: "halls-rusdram-round-hall",
    path: "/halls/rusdram-round-hall",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/rusdram-round-hall.vue")
  },
  {
    name: "halls-stage-hall",
    path: "/halls/stage-hall",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/halls/stage-hall.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/asar-studio/ticket-me-biz/ticketme/web/widget/src/pages/index.vue")
  }
]